import MyContext from '@/shared/contexts/AppContext';
import FontSizeControl from '@/shared/components/layout/FontSizeControl';
import NotificationBell from './NotificationBell';
import { CarregarPermissoes, ValidarPermissao, } from '@/modules/system/auth/application/auth.service';
import { Link } from 'react-router-dom';
import { Links } from '@/shared/constants/navegacao';
import { visaoExibeMeuPerfil } from '@/shared/constants/visao-sistema.constants';
import { useNavigationView } from '@/shared/hooks/useNavigationView';
import { PermissionEnum } from '@/modules/system/auth/domain/enums/permission.enum';
import { RoleEnum } from '@/modules/system/auth/domain/enums/role.enum';
import { useContext, useEffect, useMemo } from 'react';

const NAVBAR_TITULO = 'SGI - Sistema de Gestão Interna';
const NAVBAR_CLASSE = 'background-ferias';
const NAVBAR_COR = 'bg-green';

export default function Navbar() {
  const context = useContext(MyContext);
  const { effectiveView } = useNavigationView();
  const exibirMeuPerfil = visaoExibeMeuPerfil(effectiveView);

  if (!context) throw new Error('Navbar must be used within a MyProvider');

  const { state } = context;

  const permissoes = useMemo(() => CarregarPermissoes(), []);

  const permissaoAcoes = ValidarPermissao(permissoes, [{ role: RoleEnum.MOVIMENTACAO, level: PermissionEnum.READ }]);
  const permissaoAtuacao = ValidarPermissao(permissoes, [{ role: RoleEnum.ATUACAO, level: PermissionEnum.READ }]);
  const permissaoComarca = ValidarPermissao(permissoes, [{ role: RoleEnum.COMARCA, level: PermissionEnum.READ }]);
  const permissaoDefensores = ValidarPermissao(permissoes, [{ role: RoleEnum.DEFENSOR, level: PermissionEnum.READ }]);
  const permissaoDefensoria = ValidarPermissao(permissoes, [{ role: RoleEnum.DEFENSORIA, level: PermissionEnum.READ }]);
  const permissaoDistritos = ValidarPermissao(permissoes, [{ role: RoleEnum.DISTRITO, level: PermissionEnum.READ }]);
  const permissaoEstagiarios = ValidarPermissao(permissoes, [{ role: RoleEnum.ESTAGIARIO, level: PermissionEnum.READ }]);
  const permissaoFerias = ValidarPermissao(permissoes, [{ role: RoleEnum.LOTACAO, level: PermissionEnum.READ }]);
  const permissaoFolhas = ValidarPermissao(permissoes, [{ role: RoleEnum.FOLHA, level: PermissionEnum.READ }]);
  const permissaoForum = ValidarPermissao(permissoes, [{ role: RoleEnum.PREDIO, level: PermissionEnum.READ }]);
  const permissaoColaboradores = ValidarPermissao(permissoes, [{ role: RoleEnum.COLABORADOR, level: PermissionEnum.READ }]);
  const permissaoLogs = ValidarPermissao(permissoes, [{ role: RoleEnum.ADMIN_ACTIONS, level: PermissionEnum.READ }]);
  const permissaoLotacoes = ValidarPermissao(permissoes, [{ role: RoleEnum.LOTACAO, level: PermissionEnum.READ }]);
  const permissaoOffice = ValidarPermissao(permissoes, [{ role: RoleEnum.ADMIN_ACTIONS, level: PermissionEnum.READ }]);
  const permissaoMovimentos = ValidarPermissao(permissoes, [{ role: RoleEnum.MOVIMENTACAO, level: PermissionEnum.READ }]);
  const permissaoNucleos = ValidarPermissao(permissoes, [{ role: RoleEnum.NUCLEO, level: PermissionEnum.READ }]);
  const permissaoPessoasLeitura = ValidarPermissao(permissoes, [{ role: RoleEnum.PESSOA, level: PermissionEnum.READ }]);
  const permissaoRegras = ValidarPermissao(permissoes, [{ role: RoleEnum.GERENCIAR_REGRAS, level: PermissionEnum.READ }]);
  const permissaoVara = ValidarPermissao(permissoes, [{ role: RoleEnum.VARA, level: PermissionEnum.READ }]);

  useEffect(() => {
    const root = document.getElementById('root');
    if (root) {
      root.className = NAVBAR_CLASSE;
    }
  }, []);

  if (!state.navbar) {
    return null;
  }

  return (
    <nav
      className={`navbar navbar-expand-lg navbar-dark sticky-top d-print-none ${NAVBAR_COR}`}
    >
      <div
        className="container container-principal collapse navbar-collapse"
        id="navbarsExampleDefault"
      >
        <div className="d-flex flex-grow-1">
          <Link
            className="navbar-brand"
            to={Links.Index}
            title="Ir para Página Inicial"
          >
            {NAVBAR_TITULO}
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <span className="navbar-brand ps-3 small">{state.nome}</span>
          <div
            className="collapse navbar-collapse"
            id="navbarSupportedContent"
          ></div>
        </div>

        <ul className="navbar-nav mr-auto">
          {permissaoAcoes && (permissaoFerias || permissaoMovimentos) && (
            <li className="nav-item dropdown dropdown-hover">
              <Link
                id="dropdownacoes"
                to="#"
                title="Ações"
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Eventos
              </Link>
              <div className="dropdown-menu" aria-labelledby="dropdownacoes">
                {permissaoFerias && (
                  <Link
                    className="dropdown-item"
                    to={Links.Acoes_Criar}
                    title="Abonos, faltas, férias etc."
                  >
                    Cadastro de Ações
                  </Link>
                )}
                {permissaoRegras && permissaoFerias && (
                  <Link
                    className="dropdown-item"
                    to={Links.Regras}
                    title="Regras para validar as ações."
                  >
                    Regras de validação
                  </Link>
                )}
                {permissaoFerias && <div className="dropdown-divider"></div>}
                {permissaoFerias && (
                  <Link
                    className="dropdown-item"
                    to={Links.Relatorio_Ferias}
                    title="Tabela de Ações."
                  >
                    Tabelas de Ações
                  </Link>
                )}
                {permissaoMovimentos && (
                  <Link
                    className="dropdown-item"
                    to={Links.Movimentacoes_Index}
                    title="Registro de atendimentos."
                  >
                    Cadastro de Movimentações
                  </Link>
                )}
                {permissaoMovimentos && <div className="dropdown-divider"></div>}
                {permissaoMovimentos && (
                  <Link
                    className="dropdown-item"
                    to={Links.Relatorio_Movimentacoes}
                    title="Tabela de movimentações."
                  >
                    Tabela de Movimentações
                  </Link>
                )}
                {permissaoMovimentos && <div className="dropdown-divider"></div>}
                {permissaoMovimentos && (
                  <Link className="dropdown-item" to={Links.Movimentacoes_Lista} title="Pequisa de Movimentações.">
                    Todas as Movimentaçoes
                  </Link>
                )}
                {(permissaoFerias || permissaoMovimentos) && <div className="dropdown-divider"></div>}
                {(permissaoFerias || permissaoMovimentos) && (
                  <Link className="dropdown-item" to={Links.Pontuacoes_Index} title="Lista de defensores com pontuações.">
                    Pontuações
                  </Link>
                )}
              </div>
            </li>
          )}

          {(permissaoFerias || permissaoLotacoes) && (
            <li className="nav-item dropdown dropdown-hover">
              <Link
                id="dropdownlotacoes"
                to="#"
                title="Vínculos"
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Vínculos
              </Link>
              <div className="dropdown-menu" aria-labelledby="dropdownlotacoes">
                {permissaoLotacoes && (
                  <>
                    <Link
                      className="dropdown-item"
                      to={`${Links.Vinculos_Index}?tipo=defensor`}
                      title="Vínculos de Defensores."
                    >
                      Para Defensores
                    </Link>
                    <Link
                      className="dropdown-item"
                      to={`${Links.Vinculos_Index}?tipo=colaborador`}
                      title="Vínculos de Colaboradores."
                    >
                      Para Colaboradores
                    </Link>
                    {permissaoEstagiarios && (
                      <Link
                        className="dropdown-item"
                        to={`${Links.Vinculos_Index}?tipo=estagiario`}
                        title="Vínculos de Estagiários."
                      >
                        Para Estagiários
                      </Link>
                    )}
                    <div className="dropdown-divider"></div>
                  </>
                )}
                <Link
                  className="dropdown-item"
                  to={Links.Relatorio_Lotacoes}
                  title="Tabelas de vínculos."
                >
                  Tabelas de Vínculos
                </Link>
              </div>
            </li>
          )}
          {permissaoFolhas && (
            <div>
              <Link
                id="dropdownfrequencias"
                to={Links.ProcessoSeletivo_Index}
                title="Controle de Frequências dos Estagiários"
                className="nav-link"
              >
                Processo Seletivo
              </Link>
            </div>
          )}

          {permissaoFolhas && (
            <li className="nav-item dropdown dropdown-hover">
              <Link
                id="dropdownfrequencias"
                to="#"
                title="Controle de Frequências dos Estagiários"
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Frequências
              </Link>
              <div className="dropdown-menu" aria-labelledby="dropdownfrequencias" >
                <Link className="dropdown-item" to={Links.Folha_Frequencia_Index} title="Visualiza folhas de frequências do mês.">
                  Folhas de Frequência
                </Link>
                <Link className="dropdown-item" to={Links.Folha_Frequencia_Pendencias} title="Lista folhas não concluídas (pendências), ignorando período.">
                  Pendências
                </Link>
                <div className="dropdown-divider"></div>
                {/* <Link className="dropdown-item" to={Links.Folha_Frequencia_Index + "/folhas"} title="Visualiza folhas de frequências de um estagiário.">
                  Por Estagiário
                </Link>
                <div className="dropdown-divider"></div> */}
                <Link
                  className="dropdown-item"
                  to={Links.Calendario_Index}
                  title="Cadastro e edição de feriados e pontos facultativos."
                >
                  Calendário de Bloqueios
                </Link>
              </div>
            </li>
          )}

          <li className="nav-item dropdown dropdown-hover">
            <Link
              id="dropdowncadastros"
              className="nav-link dropdown-toggle"
              to="#"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Cadastros Gerais
            </Link>
            <div className="dropdown-menu" aria-labelledby="dropdowncadastros">
              {permissaoComarca && (
                <Link
                  className="dropdown-item"
                  to={Links.Comarcas_Index}
                  title="Lista de comarcas."
                >
                  Comarcas
                </Link>
              )}
              {permissaoDistritos && (
                <Link
                  className="dropdown-item"
                  to={Links.Distrito_Index}
                  title="Lista de distritos por defensoria."
                >
                  Distritos
                </Link>
              )}
              {permissaoDistritos && (
                <Link
                  className="dropdown-item"
                  to={Links.Diretoria_Index}
                  title="Lista de diretorias."
                >
                  Diretoria
                </Link>
              )}
              {permissaoForum && (
                <Link
                  className="dropdown-item"
                  to={Links.Predio_Index}
                  title="Lista de fóruns ou prédios."
                >
                  Fóruns/Unidades
                </Link>
              )}
              {permissaoForum && (
                <Link
                  className="dropdown-item"
                  to={Links.Setor_Index}
                  title="Lista de setores."
                >
                  Setores
                </Link>
              )}
              {permissaoVara && (
                <Link
                  className="dropdown-item"
                  to={Links.Varas_Index}
                  title="Varas das defensorias."
                >
                  Varas/Centrais
                </Link>
              )}
              {permissaoAtuacao && (
                <Link
                  className="dropdown-item"
                  to={Links.Atuacoes_Index}
                  title="Atuações das defensorias."
                >
                  Esferas de Atuação
                </Link>
              )}
              {permissaoEstagiarios && (
                <Link
                  className="dropdown-item"
                  to={Links.Instituicoes_Index}
                  title="Lista de instituições de ensino."
                >
                  Inst. Ensino
                </Link>
              )}
              <div className="dropdown-divider"></div>
              {permissaoDefensoria && (
                <Link
                  className="dropdown-item"
                  to={Links.Defensoria_Index}
                  title="Lista de defensorias."
                >
                  Defensorias
                </Link>
              )}
              {permissaoNucleos && (
                <Link
                  className="dropdown-item"
                  to={Links.Nucleo_Index}
                  title="Lista de núcleos."
                >
                  Núcleos
                </Link>
              )}
              {permissaoMovimentos && (
                <>
                  <div className="dropdown-divider"></div>
                  <Link
                    className="dropdown-item"
                    to={Links.Movimentacoes_Tipos_Index}
                    title="Tipos movimentações."
                  >
                    Tipos Movimentações
                  </Link>
                </>
              )}
            </div>
          </li>

          <li className="nav-item dropdown dropdown-hover">
            <Link id="dropdownpessoal" className="nav-link dropdown-toggle" to="#" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              Pessoal
            </Link>
            <div className="dropdown-menu" aria-labelledby="dropdownpessoal">
              {(permissaoDefensores || permissaoEstagiarios || permissaoPessoasLeitura || permissaoColaboradores) && (
                <Link className="dropdown-item" to={Links.Pessoa_Index} title="Cadastro unificado de pessoas.">
                  Cadastros de pessoas
                </Link>
              )}
              {permissaoColaboradores && (
                <>
                  <div className="dropdown-divider"></div>
                  <Link className="dropdown-item" to={Links.Funcao_Index} title="Funções para Colaboradores.">
                    Funções
                  </Link>
                </>
              )}
            </div>
          </li>

          {permissaoOffice && (
            <li className="nav-item dropdown dropdown-hover">
              <Link
                id="dropdownoffice"
                to="#"
                title="Office"
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Escritório
              </Link>
              <div className="dropdown-menu" aria-labelledby="dropdownoffice">
                <Link
                  className="dropdown-item"
                  to={Links.Gasto_Index}
                  title="Controle de gastos do setor."
                >
                  Gastos
                </Link>
                <Link
                  className="dropdown-item"
                  to={Links.TipoGasto_Index}
                  title="Tipos de gastos."
                >
                  Tipos de Gasto
                </Link>
              </div>
            </li>
          )}

          <li className="nav-item dropdown dropdown-hover">
            <Link className="nav-link dropdown-toggle" to="#" id="dropdownsistema" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >
              Sistema
            </Link>
            <div className="dropdown-menu" aria-labelledby="dropdownsistema">
              {exibirMeuPerfil && (
                <Link className="dropdown-item" to={Links.Usuario_Profile} title="Seu perfil" >
                  Meu Perfil
                </Link>
              )}
              <Link className="dropdown-item" to={Links.Notificacoes_index} title="Suas Notificações" >
                Notificações
              </Link>
              <div className="dropdown-divider"></div>
              {permissaoLogs && (
                <>
                  <Link
                    className="dropdown-item"
                    to={Links.Auditorias_Index}
                    title="Auditorias"
                  >
                    Auditorias
                  </Link>
                  <Link
                    className="dropdown-item"
                    to={Links.Configuracoes_Index}
                    title="Configurações"
                  >
                    Configurações
                  </Link>
                  <div className="dropdown-divider"></div>
                </>
              )}
              <Link
                className="dropdown-item"
                to="http://wiki.defensoria.se/pt-br/sistemas/corregedoria/inicio"
                target="_blank"
                title="Ajuda"
              >
                Ajuda
              </Link>
              <Link
                className="dropdown-item"
                to={Links.Auth_Logout}
                title="Sair do sistema"
              >
                Sair
              </Link>
            </div>
          </li>

          <li className="nav-item d-flex align-items-center me-2">
            <FontSizeControl />
          </li>

          <li>
            <NotificationBell />
          </li>

        </ul>
      </div>
    </nav>
  );
}
